export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 14a2 2 0 100-4 2 2 0 000 4zm8 0a2 2 0 100-4 2 2 0 000 4zm10-2a2 2 0 11-4 0 2 2 0 014 0z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "32",
    "height": "24",
    "viewBox": "0 0 32 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};